<template>
    <label
        class="ds-selectable-item mb-0"
        :class="{ 'ds-card-radio-disabled': disabled }"
        :for="inputId"
    >
        <CardSelectableItem
            v-bind="$attrs"
            :autoFocus
            :disabled
            :error
            :formControlPosition
            :helperText
            :label
            :selected="isEqual(model, value)"
        >
            <template #formControl>
                <DsRadio
                    v-model="model"
                    :disabled
                    :inputId
                    :name
                    noLabelWrapper
                    :value
                />
            </template>
            <slot v-if="$slots.default" />
        </CardSelectableItem>
    </label>
</template>

<script setup lang="ts" generic="T">
import CardSelectableItem from '@/components/design-system/form/input/CardSelectableItem.vue';
import DsRadio from '@/components/design-system/form/input/DsRadio.vue';
import { isEqual } from 'lodash';
import { useId } from 'vue';

export interface DsCardRadioProps<T> {
    label?: string;
    helperText?: string;
    name?: HTMLInputElement['name'];
    value: T;
    error?: string | boolean;
    autoFocus?: boolean;
    formControlPosition?: 'left' | 'right';
    inputId?: HTMLInputElement['id'];
    disabled?: boolean;
}

const props = withDefaults(defineProps<DsCardRadioProps<T>>(), {
    error: false,
    autoFocus: false,
    formControlPosition: 'left',
    disabled: false,
});

const name = props.name ?? useId();
const inputId = props.inputId ?? useId();

const model = defineModel<T>();

defineSlots<{
    default: () => void;
}>();
</script>

<style scoped lang="scss">
.ds-card-radio-disabled {
    @apply pointer-events-none cursor-not-allowed;
}
</style>
